/* GASSISA
=========================================================================================
* Descripcion: Contenedor portatil para buscar remisiones de devoluciones.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de modal portatil independiente
* ---------------------------------------------------------------------------------------
*/

import { Modal } from "@mui/material";

export const modalBuscarRemisionesPortatilStyle = {
  width: "min(96vw, 1080px)",
  height: "92vh",
  padding: { xs: "10px", sm: "14px" },
};

export default function ModalBuscarRemisionesDevolucionesPortatil({ children, ...props }) {
  return (
    <Modal className="modal-buscar-remisiones-devoluciones-portatil" {...props}>
      {children}
    </Modal>
  );
}
